import React from 'react';
import type { DropdownIndicatorProps, GroupBase } from 'react-select';
import { components } from 'react-select';

// this overrides the default dropdown arrow
const DropdownIndicator = <
    Option,
    IsMulti extends boolean = boolean,
    Group extends GroupBase<Option> = GroupBase<Option>,
>(
    props: DropdownIndicatorProps<Option, IsMulti, Group>,
) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <i translate="no" className="material-symbols-outlined caret-icon">
                    expand_more
                </i>
            </components.DropdownIndicator>
        )
    );
};

export default DropdownIndicator;
